import React, { useState, useEffect, useRef } from 'react';
import { getField } from '../../../../Services/tooltipService';
import { getCustomerFields } from '../../../../Services/fieldsServices';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import Portfolio from './Portfolio'
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import ExcelUploader from "./excelUploader";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { updateToolTip } from '../../../../Services/tooltipService';
import Loader from "../../../../Components/UiComponents/Loader";
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import { useNavigate } from 'react-router-dom';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

export default function ToolTip() {

    const { control, handleSubmit, formState: { errors } } = useForm();
    const [clientModuleData, setClientModuleData] = useState(null);
    const [labelNamePipeline, setLabelNamePipeline] = useState([]);
    const [labelNameClients, setLabelNameClients] = useState([]);
    const [labelNameFrameworks, setLabelNameFrameworks] = useState([]);
    const [modules, setModules] = useState([]);
    const [moduleTabs, setModuleTabs] = useState({});
    const [customerId, setCustomerId] = useState(null);
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedSubModuleField, setSelectedSubModuleField] = useState(null);
    const [customerData, setCustomerData] = useState([]);
    const [selectedTooltipData, setSelectedTooltipData] = useState([]);
    const [subMobuleTabs, setSubMobuleTabs] = useState([]);
    const [uploadPopup, setUploadPopup] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeIndex1, setActiveIndex1] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()
    
    const toastRef = useRef();

    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;

            // Setting customer ID state
            setCustomerId(customer);
        }else {
            navigate("/login")
            localStorage.clear()
          }

        getFieldConfig();
        getCustomer();
    }, [customerId])

    const getCustomer = async () => {
        try {
            if (customerId === null) {
                return;
            }
            if (customerId !== null) {
                const response = await getCustomerFields(customerId);
                let data = response?.data
                setCustomerData(data?.tooltips)
                const extractedData = getEvenIndexValues(data?.tooltips?.pipeline?.summary)
                setSelectedTooltipData(extractedData)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    function getEvenIndexValues(data) {
        const result = {};

        for (const [key, value] of Object.entries(data)) {
            if (value.index % 2 === 0 && key !== 'subcontractor_details') {
                result[key] = value;
            }
        }

        return result;
    }


    // Function to get customer fields data
    const getFieldConfig = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            if (customerId !== null) {
                const response = await getField(customerId);
                let data = response?.data;
                const pipelineModules = _.find(data.cust[0].modules, { module_name: "Pipeline" }).sub_modules;
                const clientsModules = _.find(data.cust[0].modules, { module_name: "Clients" }).sub_modules;
                const frameworksModules = _.find(data.cust[0].modules, { module_name: "Frameworks" }).sub_modules;

                setLabelNamePipeline(pipelineModules);
                setLabelNameClients(clientsModules);
                setLabelNameFrameworks(frameworksModules);

                const newModules = [
                    { id: 0, label: _.find(data.cust[0].modules, { module_name: "Pipeline" }).display_name, value: 'pipeline' },
                    { id: 0, label: _.find(data.cust[0].modules, { module_name: "Clients" }).display_name, value: 'client' },
                    { id: 0, label: _.find(data.cust[0].modules, { module_name: "Frameworks" }).display_name, value: 'framework' }
                ];

                setModules(newModules);
                setSelectedModule(newModules[0].value);

                const initialModuleTabs = {
                    pipeline: [
                        { id: 0, label: _.find(pipelineModules, { sub_module_name: "Summary" }).display_name, value: 'summary' },
                        { id: 1, label: _.find(pipelineModules, { sub_module_name: "Selectivity" }).display_name, value: 'selectivity' },
                        { id: 2, label: _.find(pipelineModules, { sub_module_name: "Detail" }).display_name, value: 'detail' },
                        { id: 3, label: _.find(pipelineModules, { sub_module_name: "Risks" }).display_name, value: 'risks' },
                        { id: 4, label: _.find(pipelineModules, { sub_module_name: "Gateways" }).display_name, value: 'gateways' },
                        { id: 5, label: 'Others', value: 'others' }
                    ],
                    client: [
                        { id: 0, label: _.find(clientsModules, { sub_module_name: "Summary" }).display_name, value: 'summary' },
                        { id: 1, label: _.find(clientsModules, { sub_module_name: "Relationship Development Score" }).display_name, value: 'rds' },
                        { id: 2, label: 'Others', value: 'others' }
                    ],
                    framework: [
                        { id: 0, label: _.find(frameworksModules, { sub_module_name: "Summary" }).display_name, value: 'summary' }
                    ]
                };
                setModuleTabs(initialModuleTabs);
                setSubMobuleTabs(initialModuleTabs?.pipeline)

                // Initialize selectedSubModuleField with the first sub-module of the first module (pipeline as an example)
                setSelectedSubModuleField(initialModuleTabs?.pipeline[0].value);

                // let portfolio = _.find(pipelineModules, {sub_module_name: initialModuleTabs.pipeline[0].value})

                const portfolio = pipelineModules.find(item => item.sub_module_name === "Summary");
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };


    const selectField = (value) => {
        const data = customerData[value]
        let moduletab = moduleTabs[value][0].value;
        setSelectedSubModuleField(moduletab);
        setSubMobuleTabs(moduleTabs[value])
        const extractedData = getEvenIndexValues(customerData[value][moduletab])
        setSelectedTooltipData(extractedData)
        setSelectedModule(value);
    };


    const selectedSubModules = (selectedValue) => {
        // Check if the module exists
        if (!customerData[selectedModule]) {
            return `Module ${selectedModule} not found.`;
        }

        setSelectedSubModuleField(selectedValue);
        const extractedData = getEvenIndexValues(customerData[selectedModule][selectedValue])
        setSelectedTooltipData(extractedData)
    };

    const gettingData = (data, key) => {
        const newResponse = { ...customerData[selectedModule][selectedSubModuleField][key] };
        setCustomerData((prevState) => ({
            ...prevState,
            [selectedModule]: {
                ...prevState[selectedModule],
                [selectedSubModuleField]: {
                    ...prevState[selectedModule][selectedSubModuleField],
                    [key]: newResponse
                }
            }
        }));

        updateResponse(newResponse, data)
        removeUnwantedKeys(newResponse);

    };

    const removeUnwantedKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            if (isNaN(Number(key))) {
                newObj[key] = obj[key];
            }
        });

        let updatedCustomerData = deepCopy(customerData);
        updateNestedObject(updatedCustomerData, Object.keys(selectedTooltipData), newObj);
    };
    const deepCopy = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    const updateNestedObject = (data, submoduleKey, updatedSubmodule) => {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {

                if (key === submoduleKey) {
                    // Update the submodule with the new values
                    data[key] = { ...updatedSubmodule };
                } else if (typeof data[key] === 'object' && data[key] !== null) {
                    // Recursively search within the nested object
                    updateNestedObject(data[key], submoduleKey, updatedSubmodule);
                }
            }
        }
    };

    const findAndUpdateSubmodule = (data, updates, subModuleName) => {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === subModuleName) {
                    // Found the submodule, update it
                    updateNestedSubmodule(data[key], updates);
                } else if (typeof data[key] === 'object' && !Array.isArray(data[key])) {
                    // Recursively search in the nested object
                    findAndUpdateSubmodule(data[key], updates, subModuleName);
                }
            }
        }
    };

    const updateNestedSubmodule = (original, updates) => {
        for (const key in updates) {
            if (updates.hasOwnProperty(key)) {
                // Check if the key exists in the original object
                if (original.hasOwnProperty(key)) {
                    // If both original and update are objects, recurse
                    if (typeof original[key] === 'object' && !Array.isArray(original[key])) {
                        updateNestedSubmodule(original[key], updates[key]);
                    } else {
                        // Otherwise, directly update the value
                        original[key] = updates[key];
                    }
                } else {
                    // If the key does not exist, add it
                    original[key] = updates[key];
                }
            }
        }
    };


    const updateResponse = (target, source) => {
        for (let key in source) {
            if (source.hasOwnProperty(key)) {
                if (typeof source[key] === 'object' && !Array.isArray(source[key]) && source[key] !== null) {
                    if (!target[key]) {
                        target[key] = {};
                    }
                    updateResponse(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
        }
    };

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const onCloseUploadPopup = () => {
        setUploadPopup(false);
    };

    const moduleTemplate = (value) => {
        if(customerData){
            if (moduleTabs) {
                let moduletab = moduleTabs[modules[value.index].value][0].value;
                setSelectedSubModuleField(moduletab);
                setSubMobuleTabs(moduleTabs[modules[value.index].value])
                const extractedData = getEvenIndexValues(customerData[modules[value.index].value][moduletab])
                setSelectedTooltipData(extractedData)
                setSelectedModule(modules[value.index].value);
                setActiveIndex(value.index)
            }
        }else{
            toastRef.current.showToast({
                type: 'error',
                message: 'Error in getting Customer Data. Please Try Again or Contact Admin'
            });
        }
    }

    const submoduleTemplate = (val) => {
        if(customerData){
            if (!customerData[selectedModule]) {
                return `Module ${selectedModule} not found.`;
            }
    
            setSelectedSubModuleField(subMobuleTabs[val.index].value);
            const extractedData = getEvenIndexValues(customerData[selectedModule][subMobuleTabs[val.index].value])
            setSelectedTooltipData(extractedData)
            setActiveIndex1(val.index)
        }else{
            toastRef.current.showToast({
                type: 'error',
                message: 'Error in getting Customer Data. Please Try Again or Contact Admin'
            });
        }
    }

    const onSubmit = async () => {
        try {
            if (customerId === null) {
                return;
            }
            const tooltipResponse = await updateToolTip(customerId, customerData)

            if (tooltipResponse && tooltipResponse.status === 200) {
                toastRef.current.showToast({
                    type: 'success',
                    message: 'Tooltip Info Updated Successfully'
                });
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Error in Tooltip updating'
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }

    const handleButtonClick = () => {
        setShowVideo(true);
      };
    
      const closeVideo = () => {
          setShowVideo(false);
      };

    return (
        <>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="group-table-component">
                <div className='d-flex justify-between'>
                    <p className="fs-16 fw-600 mar-b-3">ToolTip</p>
                    <div>
                        <ButtonElement
                            className="upload-button"
                            type="button"
                            icon="pi pi-upload"
                            onClick={() => setUploadPopup(true)} />
                        <ButtonElement className="upload-button ml-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement> 
                    </div>
                </div>
                <div className='mt-30'>
                    <p className="fs-14 mar-b-3">Modules:</p>
                    <TabView activeIndex={activeIndex} onTabChange={(e) => moduleTemplate(e)}>
                        {
                            modules.length > 0 && modules.map(m => {
                                return (
                                    <TabPanel header={m.label} key={m.id} >
                                        {/* <div className='vertical-tabview'> */}
                                        <div className='vertical-tabview'>
                                            <p className="fs-14 mar-b-3">Tabs:</p>
                                            <TabView activeIndex={activeIndex1} onTabChange={(e) => submoduleTemplate(e)}>
                                                {
                                                    subMobuleTabs.length > 0 && subMobuleTabs.map(sm => {
                                                        return (
                                                            <TabPanel header={sm.label} key={sm.id}>
                                                                <div className="app-container">
                                                                    <div className="flex-1">
                                                                        <div className="width-100">
                                                                            <div>
                                                                                <div className='d-flex justify-between align-center'>
                                                                                    <p className='bread-crumb'>{m.label + " " + '>' + " " + sm.label}</p>
                                                                                    <div className="cancel-footer d-flex justify-end">
                                                                                        <div className='align-center justify-end pb-0'>
                                                                                            <ButtonElement type="submit" label="Save" className="save-button" onClick={onSubmit} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {Object.keys(selectedTooltipData).map((key) => (
                                                                                    <div key={key} className='mt-10'>
                                                                                        <Accordion activeIndex={0}>
                                                                                            <AccordionTab header={capitalizeFirstLetter(key)} disabled>
                                                                                                <div>
                                                                                                    <Portfolio fields={selectedTooltipData[key]} getData={(data) => gettingData(data, key)} />
                                                                                                </div>
                                                                                            </AccordionTab>
                                                                                        </Accordion>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </TabPanel>
                                                        )
                                                    })
                                                }
                                            </TabView>
                                        </div>
                                    </TabPanel>
                                )
                            })
                        }
                    </TabView>
                    <Dialog
                        header={"Upload Formatted spreadsheet"}
                        visible={uploadPopup}
                        position="top"
                        className='width-50vw'
                        onHide={onCloseUploadPopup}
                        draggable={false}
                    >
                        <ExcelUploader onCloseUploadPopup={onCloseUploadPopup} />
                    </Dialog>
                    <Dialog id="videoModal" visible={showVideo}
                        breakpoints={{
                        '1200px': '80vw',    // Larger modal on bigger screens
                        '1024px': '85vw',    // Slightly smaller for medium screens
                        '769': '90vw',     // Responsive on tablets
                        '641px': '95vw',     // Almost full-width on mobile
                        }}
                        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                    >
                        <div className="video-overlay">
                            <div className="video-container">
                                <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_tooltips" />
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
